import { socialMediaData } from "public/data/socialMedia";

/**
 * Get a flag emoji from a country code.
 * @param countryCode - A string representing the ISO3166-1 country code of a country.
 * @author https://dev.to/jorik/country-code-to-flag-emoji-a21#comment-1d92e
 * @returns A string containing the emoji flag of the country. May be null.
 */
export function getFlagEmoji(countryCode): string | null {
    return countryCode && countryCode.toUpperCase().replace(/./g, char => 
        String.fromCodePoint(127397 + char.charCodeAt())
    )
}

function getMonthName(monthNumber) {
    
    let monthName;
    switch (monthNumber) {
        case "01":
            monthName = "January";
            break;
        case "02":
            monthName = "February";
            break;
        case "03":
            monthName = "March";
            break;
        case "04":
            monthName = "April";
            break;
        case "05":
            monthName = "May";
            break;
        case "06":
            monthName = "June";
            break;
        case "07":
            monthName = "July";
            break;
        case "08":
            monthName = "August";
            break;
        case "09":
            monthName = "September";
            break;
        case "10":
            monthName = "October";
            break;
        case "11":
            monthName = "November";
            break;
        case "12":
            monthName = "December";
            break;
        default:
            monthName = "Invalid month number";
            break;
    }

    return monthName;
}

function getOrdinalNumber(day_str){
    const day_number = parseInt(day_str);
    if (day_number % 10 == 1 && day_number != 11){
        return `${day_number}st`
    }
    else if (day_number % 10 == 2 && day_number != 12){
        return `${day_number}nd`
    }
    else if (day_number % 10 == 3 && day_number != 13){
        return `${day_number}rd`
    }
    else {
        return `${day_number}th`
    }
}

export function isoStringToDate(isoString: string): string{
    const slices = isoString.split("-");
    return `${getMonthName(slices[1])} ${getOrdinalNumber(parseInt(slices[2]))}, ${slices[0]}`;
}

export function calculateAnimationDelay(index: number, numberOfItems: number, maxTime: number = 300, extraDelay: number = 0){
    if (numberOfItems % 2 === 1) return `${Math.round(maxTime * (-Math.cos((Math.PI/(numberOfItems - 1)) * Math.abs(Math.ceil(numberOfItems / 2) - (index + 1))) + 1)) + extraDelay}ms`;
    else return `${Math.round(maxTime / 2 * (-Math.cos((Math.PI/(numberOfItems / 2 - 1)) * ((numberOfItems / 2 - 1) - (Math.abs(-index + (numberOfItems - 1)/2) - 0.5)) + 1))) + extraDelay}ms`;
}

export function getSocialMediaCoordinates(platform: string){
    console.log(platform);
    return [
        `-${5 + 10 * (socialMediaData[platform].coordinates[0]) + socialMediaData[platform].coordinates[0] * 512}px`,
        `-${5 + 10 * (socialMediaData[platform].coordinates[1]) + socialMediaData[platform].coordinates[1] * 512}px`
    ]
}

/**
* Returns a hash code from a string
* @param str The string to hash.
* @return A 32bit integer
* @see http://werxltd.com/wp/2010/05/13/javascript-implementation-of-javas-string-hashcode-method/
*/
export function hashCode(str: string): number {
   let hash = 0;
   for (let i = 0, len = str.length; i < len; i++) {
       let chr = str.charCodeAt(i);
       hash = (hash << 5) - hash + chr;
       hash |= 0; // Convert to 32bit integer
   }
   return hash;
}